﻿import { FC, HTMLAttributes } from 'react';
import { Container } from './Container';

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  title?: string;
  subtitle?: string;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export const Section: FC<SectionProps> = ({
  children,
  title,
  subtitle,
  containerSize = 'xl',
  style,
  ...props
}) => {
  return (
    <section style={{ padding: '3.5rem 0', ...style }} {...props}>
      <Container size={containerSize}>
        {(title || subtitle) && (
          <div style={{ marginBottom: '2rem' }}>
            {title && (
              <h2 style={{ fontSize: '1.75rem', fontWeight: 700, color: 'var(--color-navy-dark)' }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p style={{ fontSize: '1rem', color: 'var(--color-text-secondary)', marginTop: '0.5rem' }}>
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </Container>
    </section>
  );
};

